import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Card } from 'react-bootstrap-5';

import Section from './website_section';
import SectionDropzone from './section_dropzone';
import { reorderableList } from 'helpers/react_dnd/reorderable_list';

export class WebsiteSectionList extends React.Component {
  static propTypes = {
    defaultLayout: PropTypes.bool,
    disabled: PropTypes.bool,
    layout: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
    sections: PropTypes.array.isRequired,
    sectionTypes: PropTypes.array.isRequired,
    targetGroup: PropTypes.string,
    onDeleteSection: PropTypes.func.isRequired,
    onEditSection: PropTypes.func.isRequired,
    onReorder: PropTypes.func,
  };

  dropTargetCollector = connect => (
    { connectDropTarget: connect.dropTarget() }
  );

  hasSections() {
    return this.props.sections.length > 0;
  }

  noSectionsSelectedMessage = () => {
    if (this.props.defaultLayout) {
      let text = 'Using default layout.';
      if (!this.props.disabled) {
        text += '  Add a section to customize.';
      }
      return text;
    } else {
      return 'No sections selected.';
    }
  };

  isInvalidLayout(section) {
    const sectionType = _.find(this.props.sectionTypes, type => type.key === section.sectionType);
    return sectionType.validLayouts && !_.includes(sectionType.validLayouts, this.props.layout);
  }

  render() {
    const cardClass = classNames({
      'website-section-list': true,
      'empty-list': !this.hasSections()
    });
    return (
      <Card className={cardClass} key={this.props.location}>
        <Card.Body>
          <div className="section-list">
            {this.renderSections()}
            {this.renderListEndDropzone()}
          </div>
        </Card.Body>
      </Card>
    );
  }

  renderListEndDropzone() {
    if (this.hasSections()) {
      return (
        <SectionDropzone
          index={this.props.sections.length - 1}
          listName={this.props.location}
          targetGroup={this.props.targetGroup}
          onReorder={this.props.onReorder}
        />
      );
    }
  }

  renderSections() {
    if (this.props.sections.length > 0) {
      const sections = this.props.sections.map((section, index) => {
        if (this.isInvalidLayout(section)) return null;
        return (
          <Section
            disabled={this.props.disabled}
            index={index}
            key={section.id}
            listName={this.props.location}
            section={section}
            targetGroup={this.props.targetGroup}
            onDelete={this.props.onDeleteSection}
            onEdit={this.props.onEditSection}
            onReorder={this.props.onReorder}
          />
        );
      });
      return <ul>{sections}</ul>;
    } else {
      return (
        <SectionDropzone
          index={-1}
          listName={this.props.location}
          targetGroup={this.props.targetGroup}
          onReorder={this.props.onReorder}
        >
          <div className="text-center">
            <h5 className="fw-light text-muted">{this.noSectionsSelectedMessage()}</h5>
          </div>
        </SectionDropzone>
      );
    }
  }
}

export default reorderableList(WebsiteSectionList);
